import axios from "axios";
import router from "@/router";
import alert from "@/lang/AlertMessages.js";
import { RUNTIME_ENV } from "@/runtimeEnv";
import { isNavigationFailure, NavigationFailureType } from "vue-router";
import { loadFloatAccountConfigs } from "@/containers/navbars/pbase.js";
import { loadPACNTFloatAccountConfigs } from "@/containers/navbars/pacnt.js";
import { EventBus } from "@/plugins/eventBus";

// import Vue from "vue";

if (!localStorage.DateType) {
  localStorage.setItem("DateType", 1);
}
if (!localStorage.DateTimeFormat) {
  localStorage.setItem("DateTimeFormat", 1);
}
axios.defaults.baseURL = RUNTIME_ENV.VUE_APP_API_URL;
axios.defaults.headers.common["Authorization"] = localStorage.mitaToken;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["fiscalYearId"] = localStorage.FiscalYearId;
axios.defaults.headers.common["branchId"] = localStorage.BranchId;
axios.defaults.headers.common["dateType"] = localStorage.DateType;
axios.defaults.headers.common["dateTimeFormat"] = localStorage.DateTimeFormat;
// axios.defaults.headers.common["Accept-language"] = "fa-IR";
let lang = JSON.parse(localStorage.getItem("mitaLanguage"));
if (!lang) {
  lang = 1;
  localStorage.setItem("mitaLanguage", JSON.stringify(lang));
}
if (lang === 1) {
  axios.defaults.headers.common["Accept-language"] = "fa-IR";
} else if (lang === 2) {
  axios.defaults.headers.common["Accept-language"] = "en-US";
}

function setCommonHeaders(data) {
  if (data.token) {
    localStorage.setItem("mitaToken", data.token);
    axios.defaults.headers.common["Authorization"] = data.token;
  }
  localStorage.setItem("FiscalYearId", data.fiscalYearId);
  axios.defaults.headers.common["fiscalYearId"] = data.fiscalYearId;
  localStorage.setItem("BranchId", data.branchId);
  axios.defaults.headers.common["branchId"] = data.branchId;
}

const WORKSPACE_KEY = "mitaWorkspaces";

function workspaceUserKey(data) {
  return `${data.route || ""}:${(data.username || "").trim().toLowerCase()}`;
}

function getSavedWorkspaces() {
  try {
    return JSON.parse(localStorage.getItem(WORKSPACE_KEY)) || {};
  } catch (e) {
    return {};
  }
}

function getSavedWorkspace(data) {
  return getSavedWorkspaces()[workspaceUserKey(data)] || null;
}

function removeSavedWorkspace(data) {
  const all = getSavedWorkspaces();
  delete all[workspaceUserKey(data)];
  localStorage.setItem(WORKSPACE_KEY, JSON.stringify(all));
}

function changeWorkspace(workspace) {
  return axios
    .put("base/api/v1/admin/ChangeFiscalYear/" + workspace.fiscalYearId)
    .then(() => {
      setCommonHeaders({
        branchId: workspace.branchId,
        fiscalYearId: workspace.fiscalYearId,
      });
    });
}

function saveWorkspace(data) {
  const all = getSavedWorkspaces();
  all[workspaceUserKey(data)] = {
    branchId: data.branchId,
    fiscalYearId: data.fiscalYearId,
  };
  localStorage.setItem(WORKSPACE_KEY, JSON.stringify(all));
}

// کاربری که وارد شده ولی هنوز شعبه و سال مالی را انتخاب نکرده؛
// در sessionStorage نگه داشته می‌شود تا با رفرش صفحه (مثلاً دکمهٔ بروزرسانی)
// به‌جای ورود به شعبهٔ پیش‌فرض، همان صفحهٔ انتخاب شعبه دوباره نمایش داده شود
const PENDING_WORKSPACE_KEY = "mitaPendingWorkspace";

export function getPendingWorkspace() {
  try {
    return JSON.parse(sessionStorage.getItem(PENDING_WORKSPACE_KEY));
  } catch (e) {
    return null;
  }
}

function showWorkspaceStep(commit, data) {
  sessionStorage.setItem(
    PENDING_WORKSPACE_KEY,
    JSON.stringify({ username: data.username, route: data.route }),
  );
  commit("setWorkspaceStep", true);
}

function hideWorkspaceStep(commit) {
  sessionStorage.removeItem(PENDING_WORKSPACE_KEY);
  commit("setWorkspaceStep", false);
}

// بعد از اتمام ناوبری resolve می‌شود
function enterDashboard(commit) {
  loadFloatAccountConfigs();
  loadPACNTFloatAccountConfigs();

  const navigation = router.push({ name: "Dashboard" }).catch(() => {});
  EventBus.$emit("user-logged-in");
  setTimeout(() => {
    commit("setSuccess", alert.success.login, { root: true });
  }, 800);
  return navigation;
}

export default {
  login({ dispatch, commit }, data) {
    commit("setLoginCheck", true);
    axios
      .post("base/api/v1/account", data)
      .then((res) => {
        commit("authUser", res.data.data);
        setCommonHeaders(res.data.data);

        // ورود اول: انتخاب شعبه و سال مالی، ورودهای بعدی: مستقیم داشبورد
        const saved = getSavedWorkspace(data);
        const current = res.data.data;
        if (!saved) {
          showWorkspaceStep(commit, data);
        } else if (
          saved.fiscalYearId == current.fiscalYearId &&
          saved.branchId == current.branchId
        ) {
          enterDashboard(commit);
        } else {
          // سرور فضای کاری دیگری برگردانده؛ انتخاب ذخیره‌شده اعمال می‌شود
          changeWorkspace(saved)
            .then(() => enterDashboard(commit))
            .catch(() => {
              // انتخاب قبلی دیگر معتبر نیست؛ دوباره پرسیده شود
              removeSavedWorkspace(data);
              showWorkspaceStep(commit, data);
            });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoginCheck", false);
        }, 800);
      });
  },

  // ثبت شعبه و سال مالی انتخاب‌شده در صفحهٔ ورود
  // (همان API و هدرهایی که منوی سال مالی در هدر استفاده می‌کند)
  selectWorkspace({ commit }, data) {
    commit("setWorkspaceLoading", true);
    changeWorkspace(data)
      .then(() => {
        saveWorkspace(data);
        // صفحهٔ شعبه‌ها تا پایان ورود به داشبورد نمایش داده می‌شود
        // تا فرم ورود لحظه‌ای دوباره دیده نشود
        return enterDashboard(commit).then(() => {
          hideWorkspaceStep(commit);
          commit("setWorkspaceLoading", false);
        });
      })
      .catch((error) => {
        // روی همین صفحه می‌ماند (بدون خروج از حساب) تا کاربر دوباره انتخاب کند
        const message =
          error.response &&
          error.response.data &&
          error.response.data.message;
        if (message) commit("setError", message, { root: true });
        commit("setWorkspaceLoading", false);
      });
  },

  resetPassword({ dispatch }, data) {
    axios
      .put("base/api/v1/resetPassword", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.resetPassword,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  forgotPassword({ dispatch, commit }, data) {
    commit("setForgotBtn", true);
    axios
      .put("base/api/v1/forgotPassword", data)
      .then((res) => {
        commit("setForgotCheck", false);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.forgotPassword,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setForgotBtn", false);
        }, 1000);
      });
  },

  logout({ commit }) {
    localStorage.removeItem("mitaToken");
    localStorage.removeItem("FiscalYearId");
    localStorage.removeItem("FiscalYearTitle");
    localStorage.removeItem("BranchId");
    axios.defaults.headers.common["Authorization"] = "";
    commit("clearAuth");
    hideWorkspaceStep(commit);
    // لیست زیرسیستم‌ها مربوط به شرکت کاربر قبلی است و باید دوباره خوانده شود
    commit("dropdownX/resetCompanySubSystems");
    router.push({ name: "Login" }).catch((failure) => {
      if (isNavigationFailure(failure, NavigationFailureType.redirected)) {
        const msg = "Login in order to access the admin panel";
        commit("setError", msg);
      }
    });
  },

  // profile Actions
  // پرامیس برمی‌گردد تا صفحهٔ پروفایل وضعیت بارگذاری و ذخیره را بداند
  getCurrentUser({ dispatch, commit }) {
    return axios
      .get("base/api/v1/profile")
      .then((res) => {
        commit("setCurrentUser", res.data.data);
        localStorage.setItem(
          "DateType",
          JSON.stringify(res.data.data.dateType),
        );
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  editProfile({ dispatch }, data) {
    return axios
      .put("base/api/v1/profile", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.editUser,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  addProfilePic({ dispatch }, data) {
    axios
      .post("base/api/v1/profile", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.editUser,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteProfilePic({ dispatch }) {
    axios
      .delete("base/api/v1/profile")
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  editPassword({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put("base/api/v1/profile/changePassword", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.changePassword,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changeBranchYear({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("base/changebranch?????", data)
      .then((res) => {
        localStorage.setItem("FiscalYearId", res.data.newBranchYearId);
        axios.defaults.headers.common["FiscalYearId"] =
          res.data.newBranchYearId;
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.changePassword,
            redirect: "Dashboard",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getUserSession({ dispatch, commit }) {
    axios
      .get("base/api/v1/admin/UserSession?isOpen=true")
      .then((res) => {
        commit("setUserSession", res.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  changeUserSession({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("base/api/v1/admin/UserSession/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "Dashboard",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  UploadFile({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(
        "http://whrs.mita.onp.parsinaco.com/api/v1/basic/CommodityGroup/ImportAsExcel",
        data,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editDateType({ dispatch }, data) {
    axios
      .put("base/api/v1/Profile/UpdateDateType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandlerHeader",
          {
            server: res,
            message: alert.success.editUser,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerHeader", error, { root: true });
      });
  },

  // Alert and Errors Handler ------------------------------------------------------
  successPOSTHandler({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setSuccess", data.message, { root: true });
      commit("setPostCheck", true, { root: true });
      setTimeout(() => {
        commit("setPostCheck", false, { root: true });
      }, 800);
      if (data.redirect) {
        setTimeout(() => {
          router.push({ name: data.redirect });
        }, 1500);
      }
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
      commit("setPostCheck", false, { root: true });
    } else {
      commit("setPostCheck", false, { root: true });
    }
  },

  successPOSTHandler2({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setSuccess", data.message, { root: true });
      commit("setPostCheck2", true, { root: true });
      setTimeout(() => {
        commit("setPostCheck2", false, { root: true });
      }, 800);
      if (data.redirect) {
        setTimeout(() => {
          router.push({ name: data.redirect });
        }, 2500);
      }
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
      commit("setPostCheck2", false, { root: true });
    } else {
      commit("setPostCheck2", false, { root: true });
    }
  },

  successPOSTHandlerSimple({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setSuccess", data.message, { root: true });
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
    }
  },

  successPOSTHandlerHeader({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setSuccess", data.message, { root: true });
      commit("setPostCheckHeader", true, { root: true });
      setTimeout(() => {
        commit("setPostCheckHeader", false, { root: true });
      }, 800);
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
      commit("setPostCheckHeader", false, { root: true });
    } else {
      commit("setPostCheckHeader", false, { root: true });
    }
  },

  successPOSTHandlerFiscalYear({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setSuccess", data.message, { root: true });
      commit("setPostCheckFiscalYear", true, { root: true });
      setTimeout(() => {
        commit("setPostCheckFiscalYear", false, { root: true });
      }, 800);
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
      commit("setPostCheckFiscalYear", false, { root: true });
    } else {
      commit("setPostCheckFiscalYear", false, { root: true });
    }
  },

  successPOSTHandlerSilent({ commit }, data) {
    if (data.server && data.server.status === 200) {
      if (data.redirect) {
        setTimeout(() => {
          router.push({ name: data.redirect });
        }, 2500);
      }
    } else if (data) {
      commit("setError", data.server.data.message, { root: true });
    }
  },

  successPOSTHandlerSilent2({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setPostCheck2", true, { root: true });
      setTimeout(() => {
        commit("setPostCheck2", false, { root: true });
      }, 800);
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
      commit("setPostCheck2", false, { root: true });
    } else {
      commit("setPostCheck2", false, { root: true });
    }
  },

  errorGETHandlerHeader({ dispatch, commit }, data) {
    commit("setPostCheckHeader", false, { root: true });
    if (data.response && data.response.status === 403) {
      router.push({ name: "Page403" });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (
      data.response &&
      data.response.data &&
      data.response.data.message &&
      data.response.data.message != ""
    ) {
      commit("setError", data.response.data.message, { root: true });
    }
  },

  errorPOSTHandler({ dispatch, commit }, data) {
    commit("setPostCheck", false, { root: true });
    if (data.response && data.response.status === 403) {
      commit("setError", alert.error.access, { root: true });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (
      data.response &&
      data.response.data &&
      data.response.data.message &&
      data.response.data.message != ""
    ) {
      commit("setError", data.response.data.message, { root: true });
    }
  },

  errorPOSTHandler2({ dispatch, commit }, data) {
    commit("setPostCheck2", false, { root: true });
    if (data.response && data.response.status === 403) {
      commit("setError", alert.error.access, { root: true });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (
      data.response &&
      data.response.data &&
      data.response.data.message &&
      data.response.data.message != ""
    ) {
      commit("setError", data.response.data.message, { root: true });
    }
  },

  errorPOSTHandlerHeader({ dispatch, commit }, data) {
    commit("setPostCheckHeader", false, { root: true });
    if (data.response && data.response.status === 403) {
      commit("setError", alert.error.access, { root: true });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (
      data.response &&
      data.response.data &&
      data.response.data.message &&
      data.response.data.message != ""
    ) {
      commit("setError", data.response.data.message, { root: true });
    }
  },

  errorPOSTHandlerFiscalYear({ dispatch, commit }, data) {
    commit("setPostCheckFiscalYear", false, { root: true });
    if (data.response && data.response.status === 403) {
      commit("setError", alert.error.access, { root: true });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (
      data.response &&
      data.response.data &&
      data.response.data.message &&
      data.response.data.message != ""
    ) {
      commit("setError", data.response.data.message, { root: true });
    }
  },

  errorPOSTHandlerSupport({ dispatch, commit }, data) {
    commit("setPostCheck", false, { root: true });
    if (data.response && data.response.status === 403) {
      commit("setError", alert.error.access, { root: true });
    } else if (data.response && data.response.status === 401) {
      dispatch("pparsinaX/logout", null, { root: true });
    } else if (
      data.response &&
      data.response.data &&
      data.response.data.message &&
      data.response.data.message != ""
    ) {
      commit("setError", data.response.data.message, { root: true });
    }
  },

  errorGETHandler({ dispatch, commit }, data) {
    commit("setPostCheck", false, { root: true });
    if (data.response && data.response.status === 403) {
      router.push({ name: "Page403" });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (
      data.response &&
      data.response.data &&
      data.response.data.message &&
      data.response.data.message != ""
    ) {
      commit("setError", data.response.data.message, { root: true });
    }
  },

  errorGETHandlerSilent({ dispatch, commit }, { response }) {
    commit("setPostCheck", false, { root: true });

    const status = response?.status;
    const message = response?.data?.message;

    switch (status) {
      case 403:
        router.push({ name: "Page403" });
        return;

      case 401:
        dispatch("logout", null, { root: true });
        return;

      case 504: //when user doesnt have this module
        return;

      default:
        if (message) commit("setError", message, { root: true });
    }
  },
  saveTabStateBefore({ commit }, { tabName, data }) {
    commit("saveTabState", { tabName, data });
    commit("addActiveTab", tabName);
  },

  // بازیابی state هنگام بازگشت به تب
  loadTabStateAfter({ state }, tabName) {
    return state.tabsData[tabName];
  },

  // حذف تب
  closeTab({ commit }, tabName) {
    commit("removeActiveTab", tabName);
  },

  // تمیز کردن تب‌های غیر فعال
  cleanupClosedTabs({ commit }, activeTabs) {
    commit("clearClosedTabs", activeTabs);
  },
};
